import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { PromotionReportService } from 'app/services/promotion/promotion-report.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-promo-report-form',
  templateUrl: './promo-report-form.component.html',
  styleUrls: ['./promo-report-form.component.css']
})
export class PromoReportFormComponent implements OnInit {
  form: FormGroup;
  invalidSubmit = false;
  barcodeOptions: any[] = [];
  messageIdFromBarcode: number | null = null;

  @Output() onCloseModal: EventEmitter<any> = new EventEmitter();
  @Output() onSaveReport: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private reportService: PromotionReportService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    public srvCalTranslate: CalendarTranslateService,
  ) {}
  dateFormat= this.srvCalTranslate.pcalendarTranslate.dateFormat;

  ngOnInit() {
    // Inizializzazione del form con validazioni
   
    this.form = this.fb.group({
      code: ['', Validators.required],
      description: [''],
      barcode: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    });
  }
  getFormattedDate(date: Date | string): string {
    if (!date) return ''; // Evita errori se la data è null o undefined
  
    let parsedDate: Date;
  
    if (typeof date === 'string') {
      parsedDate = new Date(date);
    } else {
      parsedDate = date;
    }
  
    if (isNaN(parsedDate.getTime())) return ''; // Controlla se la data è valida
  
    let dayFirst = this.dateFormat.startsWith('dd');
    let monthFirst = this.dateFormat.startsWith('mm');
  
    const day = ('0' + parsedDate.getDate()).slice(-2);
    const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2);
    const year = parsedDate.getFullYear().toString();
  
    if (dayFirst) {
      return day + '/' + month + '/' + year; // dd/mm/yyyy
    } else if (monthFirst) {
      return month + '/' + day + '/' + year; // mm/dd/yyyy
    } else {
      return year + '/' + month + '/' + day; // yyyy/mm/dd (fallback)
    }
  }
  

  /**
   * Carica i risultati della ricerca barcode basata sull'input utente
   */
  loadBarcodeResults(event: any) {
    const query = event.query.trim();
  
    if (query.length >= 4) {
      this.reportService.searchBarcode(query).subscribe({
        next: (results: any[]) => {
          this.barcodeOptions = results.length
            ? results.map(item => ({
                ean: item.ean_code,
                messageId: item.id_message,
                redStartDate: item.red_start_date,
                redEndDate: item.red_end_date,
                descr:item.descr_communication
              }))
            : [];
        },
        error: () => {
          this.barcodeOptions = [];
        }
      });
    } else {
      this.barcodeOptions = [];
    }
  }
  

  /**
   * Gestisce la selezione di un barcode dalla lista dei suggerimenti
   */
  onBarcodeSelect(event: any) {
    if (event && event.ean && event.messageId !== undefined) {
      this.form.get('barcode').setValue(event);
      this.messageIdFromBarcode = event.messageId;

      const startDate = new Date(event.redStartDate);
      const endDate = new Date(event.redEndDate);

      this.form.get('startDate').setValue(startDate);
      this.form.get('endDate').setValue(endDate);
    }
  }
  
  

  /**
   * Salva il report dopo aver verificato che il form sia valido
   */
  saveReport() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    this.invalidSubmit = false;

    const barcodeValue = this.form.get('barcode').value;
    const startDateValue = this.form.get('startDate').value;
    const endDateValue = this.form.get('endDate').value;

    // Controllo sulla validità del barcode selezionato
    if (!barcodeValue || !barcodeValue.ean || this.messageIdFromBarcode === null) {
      this.invalidSubmit = true;
      return;
    }

    // Controllo sulla validità delle date
    if (!startDateValue || !endDateValue) {
      this.invalidSubmit = true;
      return;
    }

    const data = {
      ean: barcodeValue.ean,
      messageId: this.messageIdFromBarcode,
      startDate: moment(startDateValue).format('YYYY-MM-DD'),
      endDate: moment(endDateValue).format('YYYY-MM-DD')
    };

    this.reportService.saveReport(data, this.form.get('code').value, this.form.get('description').value, 'COUPON')
    .subscribe({
      next: () => {
        this.onSaveReport.emit();
        this.confirmationService.confirm({
          header: this.translateService.instant('common.success'),
          message: this.translateService.instant('promo.okSave'),
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      },
      error: (err) => {
        console.error('Errore durante il salvataggio del report:', err);
        this.confirmationService.confirm({
          header: this.translateService.instant('common.error'),
          message: this.translateService.instant('promo.errorSave'),
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      }
    });
  
  }

  /**
   * Chiude il modale
   */
  closeModal() {
    this.onCloseModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/report/promo-report-list/promo-report-form/promo-report-form.component.ts